// A ΓÇÿ.tsxΓÇÖ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import { TabComponent } from '@syncfusion/ej2-react-navigations';
import FacilityStore from './../stores/FacilityStore';
import FacilityConstants from './../constants/FacilityConstants';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import * as Inovx from '@shared';
import FacilityActions from '../actions/FacilityActions';
var SystemStore = Inovx.Shared.System.Store;

var InovxControls = Inovx.Shared.Controls;
var PermissionService = Inovx.Shared.Permission.PermissionService;
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var ListHelper = Inovx.Shared.Common.ListHelper;

declare var InovxLoader: any;

const facilityImg = `${UrlUtilities.getBaseApplicationUrl()}/images/uploadIcon.png`;
interface FacilityViewProps {
    onAfterFacilityDelete?: () => void;
}

interface FacilityViewState {
    isActionInProgress?: boolean;
    actionInProgressMsg?: string;
    isAdding?: boolean;
    isEditing?: boolean;
    facility?: IFacility | any;
    validation?: IValidationDictionaryObject;
    selectedMenu?: string;
    selectedTab?: string;     
    allSchemas: ISchema[];
    selectedAdapter?: any;
    facilityAdapters?: any;
}

function getIsActionInProgress(): boolean {
    return SystemStore.isActionInProgress(FacilityConstants.FACILITY_ADD) ||
        SystemStore.isActionInProgress(FacilityConstants.FACILITY_EDIT) ||
        SystemStore.isActionInProgress(FacilityConstants.FACILITY_DELETE);
}

var _actionInProgressMsg: string
var MANAGE_FACILITY_PERMISSION = "Facility.Manage";
function getFormState(): FacilityViewState {

    // We need to get a copy of the user object here as the store does modifications
    // to the ID arrays directly and that would make the detection of any state 
    /// changes impossible.

    return {
        isAdding: FacilityStore.getIsAdding(),
        isEditing: FacilityStore.getIsEditing(),

        isActionInProgress: getIsActionInProgress(),
        actionInProgressMsg: _actionInProgressMsg,
        allSchemas: FacilityStore.getSchemas(),        
        facility: FacilityStore.getFacility(),
        validation: FacilityStore.getValidation(FacilityConstants.FACILITY_ADD_FORM),
        selectedMenu: FacilityStore.getSelectedTab(),
        selectedTab: FacilityStore.getSelectedTab(),
        facilityAdapters: FacilityStore.getFacilityAdapters(),
        
    };
}

class FacilityView extends React.Component<FacilityViewProps, FacilityViewState> {
    fileInputRef: React.RefObject<HTMLInputElement>;
    previewImage: string = '';
    tabInstance: TabComponent | any;
    constructor(props: FacilityViewProps) {
        super(props);
        this.state = getFormState();
        _actionInProgressMsg = InovxLoader.t("facility:form.saving");
        this.fileInputRef = React.createRef();
    }


    private _loadState = () => {
        this.setState(getFormState());
    }
    private _systemChange = () => {
        
        this.setState({ isActionInProgress: getIsActionInProgress() });
    }
    private _checkForUnsavedChanges = (event: any) => {
        if (FacilityStore.getHasChanges()) {
            event.returnValue = InovxLoader.t("common:msgBox.browserSaveChanges");
        };
    }

    componentDidMount() {
        FacilityStore.addChangeListener(this._loadState);
        SystemStore.addChangeListener(this._systemChange);
        window.addEventListener('beforeunload', this._checkForUnsavedChanges);        
    }

    componentDidUpdate(prevProps: FacilityViewProps, prevState: FacilityViewState) {

    }

    componentWillUnmount() {
        FacilityStore.removeChangeListener(this._loadState);
        SystemStore.removeChangeListener(this._systemChange);
        window.removeEventListener('beforeunload', this._checkForUnsavedChanges);
    }

    getFacilityAdapters = () => {
        FacilityActions.getFacilityAdapters(this.state.facility.ID);
    }
    private _onAdaptersChanged = (e: any) => {
        var value = e.target.value;
        let selectedAdapter = this.state.facilityAdapters.find((item: any) => item?.AdapterType?.AdapterType === parseInt(value));
        this.setState({ selectedAdapter: selectedAdapter });
    }
    render() {
        var hasManagePermission: boolean = PermissionService.checkPermission(MANAGE_FACILITY_PERMISSION)
        var header = InovxLoader.t('facility:header.viewFacility');
        var inputObj = {
            className: 'form-control',
            type: 'text'
        }
        let { facility, selectedTab } = this.state;
        let thumbnail = facilityImg;

        if (this.previewImage) {
            thumbnail = this.previewImage;
        } else if (facility.ThumbnailImageUrl) {
            thumbnail = facility.ThumbnailImageUrl;
        }

        var nameInput = jQuery.extend({
            id: 'facilityApp-name-input',
            name: 'Name',
            value: facility.Name
        }, inputObj);

        var locationInput = jQuery.extend({
            id: 'facilityApp-location-input',
            name: 'Location',
            value: facility.Location
        }, inputObj);

        var synopsisInput = jQuery.extend({
            id: 'facilityApp-synopsis-input',
            name: 'Synopsis',
            value: facility.Synopsis
        }, inputObj);

       
        let headertext: any;
        // Mapping Tab items Header property
        headertext = [{ text: InovxLoader.t('facility:menu.facilityDetails') }, { text: InovxLoader.t('facility:menu.integrations') }];
        var schemaOptions: any[] = [];    
        var selectSchema: ISchema = null;
        if (this.state.isAdding && !this.state.facility.SchemaID) {
            selectSchema = this.state.allSchemas[0];
            FacilityActions.editFacilityProperty(FacilityConstants.FACILITY_ADD_FORM, "SchemaID", selectSchema.ID);
        }

        for (var i in this.state.allSchemas) {
           
            if (this.state.facility.SchemaID === this.state.allSchemas[i].ID) {
                selectSchema = this.state.allSchemas[i];
                schemaOptions.push(<option selected key={this.state.allSchemas[i].ID } value={this.state.allSchemas[i].ID}>{this.state.allSchemas[i].Name}</option >);
            }
            else {
                schemaOptions.push(<option key={this.state.allSchemas[i].ID} value={this.state.allSchemas[i].ID}>{this.state.allSchemas[i].Name}</option >);
            }
        }

        const facilityDetailsTab = 
             <div className='tab-card user-form mt-15'>
                <div className="fc-margin">
                    <div className="row d-flex">
                        <div className="col-md-6 field-col">
                            <InovxControls.FormField title={`${InovxLoader.t("facility:form.name")}*`} inputName='Name'>
                                <input type="text" className="form-control" {...nameInput} readOnly={true} />
                            </InovxControls.FormField>
                        </div>
                        <div className="col-md-6 field-col">
                            <InovxControls.FormField title={`${InovxLoader.t("facility:form.location")}`} inputName='Location'>
                                <input type="text" className="form-control" {...locationInput} readOnly={true} />
                            </InovxControls.FormField>
                        </div>
                    </div>

                    <div className="fc-margin">
                        <InovxControls.FormField title={`${InovxLoader.t("facility:form.synopsis")}`} inputName='Synopsis'>
                            <textarea rows={5} {...synopsisInput} readOnly={hasManagePermission ? false : true} />
                        </InovxControls.FormField>
                    </div>

                    <div className="row d-flex">
                        <div className="col-md-6 field-col">
                            <InovxControls.FormField title={`${InovxLoader.t("facility:form.facilityOrigin")}`} inputName='facilityOrigin'>
                                <input type="text" className="form-control" name='facilityOrigin' readOnly={true} />
                            </InovxControls.FormField>
                        </div>
                        <div className="col-md-6 field-col">
                            <InovxControls.FormField title={`${InovxLoader.t("facility:form.facilityOriginElevation")}`} inputName='facilityOriginElevation'>
                                <input type="text" className="form-control" name='facilityOriginElevation' readOnly={true} />
                            </InovxControls.FormField>
                        </div>
                    </div>

                    <div className="row d-flex">
                        <div className="col-md-6 field-col">
                            <InovxControls.FormField title={`${InovxLoader.t("facility:form.facilitySchema")}*`} inputName='Schema'>
                                <select className="form-control" disabled={true}>
                                    {schemaOptions}
                                </select>
                            </InovxControls.FormField>
                        </div>                         
                    </div>

                    <div className="fc-margin">
                        <InovxControls.FormField title={`${InovxLoader.t("facility:form.thumbnail")}`} inputName='Thumbnail'>
                            <div className="d-flex j-cc f-dc">
                                <div className="thumbnail-container cursor-pointer">
                                    <img src={thumbnail} />
                                </div>
                                <div className="d-flex j-cc p-2 text-black">{InovxLoader.t('facility:form.thumbnailRecommendation')}</div>
                            </div>
                        </InovxControls.FormField>
                    </div>

                </div>
            </div>;      

        const adapters: any = this.state.facilityAdapters?.length > 0 ? this.state.facilityAdapters : [];
        var adaptersOptions: any = [<option disabled key="select" value={''}>{InovxLoader.t("facility:form.pleaseSelectAdapters")}</option >];
        for (var i in adapters) {
            adaptersOptions.push(<option key={adapters[i].AdapterType.AdapterType} value={adapters[i].AdapterType.AdapterType}>{adapters[i].AdapterType.AdapterName}</option >);
        }
        const getFormInput = (field: any, key: number) => {
            let fieldName = field.DisplayName.replace(/\s+/g, '_');
            if (field.ConfigurationItemDataType === 1) {
                return <input key={key} type="text" className="form-control" name={fieldName} autoComplete={fieldName} value={field.Value} readOnly />
            } else if (field.ConfigurationItemDataType === 2) {
                const content = () => {
                    let style = {
                        padding: '5px'
                    }
                    return (<div id='tooltipContent' style={style }>{field.Value}</div>);
                }
               
                return <div className="w-100" >
                    <TooltipComponent height="300px" content={content} position="TopRight">
                        <input key={key} type="text" readOnly className="form-control" name={fieldName} autoComplete={fieldName} value={field.Value} />
                    </TooltipComponent>
                </div>
            } else if (field.ConfigurationItemDataType === 3) {
                return <input key={key} type="password" className="form-control" name={fieldName} autoComplete={fieldName} value={field.Value} readOnly />
            }
        }
        const integrationTab =
            <div className='tab-card user-form  mt-15'>
                <div className="fc-margin">

                    <div className="row d-flex">
                        <div className="col-md-6 field-col">
                            <InovxControls.FormField title={`${InovxLoader.t("facility:form.selectAdapterToConfigure")}`} inputName='Adapters'>
                                <select className="form-control" value={this.state.selectedAdapter?.AdapterType?.AdapterType || ""} onChange={this._onAdaptersChanged}>
                                    {adaptersOptions}
                                </select>
                            </InovxControls.FormField>
                        </div>
                    </div>


                    {this.state.selectedAdapter && this.state.selectedAdapter.AdapterConfigurationItemModels.map((row: IFacilityAdapterConfiguration, key: number) => {
                        return <div className="row d-flex" key={key}>
                            <div className="col-md-12 field-col">
                                <InovxControls.FormField title={`${row.DisplayName}${row?.IsRequired ? '*' : ''}`} inputName={row.DisplayName}>
                                    {getFormInput(row, key)}
                                </InovxControls.FormField>
                            </div>
                        </div>
                    })}

                   {/* {this.state.isXMLEditorVisible && <XMLEditor data={this.state.editXMLData} onSave={this.onSaveXML} />}*/}

                    <input type="password" name="password" autoComplete="password" defaultValue="123" className="hidden-input" />
                    {/* fack input to avoid autocomplete*/}
                </div>
            </div>;
        return (
            <InovxControls.StaticHeaderForm title={header}>
                <div>
                    <div className="tab-container">

                        <ul className="nav nav-tabs">
                            <li onClick={(e: any) => FacilityActions.selectTab('details')} className={`${selectedTab === 'details' ? 'active' : ''}`}><a data-toggle="tab" href="#tab1">{headertext[0].text}</a></li>
                            <li onClick={(e: any) => { FacilityActions.selectTab('integrations'); this.getFacilityAdapters(); }} className={`${selectedTab === 'integrations' ? 'active' : ''}`}><a data-toggle="tab" href="#tab4">{headertext[1].text}</a></li>
                        </ul>

                        <div className="tab-content">
                            <div id="tab1" className={`tab-pane fade ${selectedTab === 'details' ? 'in active' : ''}`}>
                                <div className="entitlement-permissions">
                                    {facilityDetailsTab}
                                </div>
                            </div>
                            <div id="tab4" className={`tab-pane fade ${selectedTab === 'integrations' ? 'in active' : ''}`}>
                                {this.state.selectedTab === 'integrations' && integrationTab}
                            </div>
                        </div>

                    </div>
                </div>
            </InovxControls.StaticHeaderForm>
        );
    }
}

export default FacilityView;
